import { EnumStatusPedido } from "../../enums/enum-status-pedido";

export class StatusModel {
   constructor(
      public codigo: EnumStatusPedido = EnumStatusPedido.AguardandoInicio,
      public descricao: string = '',
   ) { }
}